export type UIState = "open" | "closed";
export const isOpen = (state: UIState): boolean => state === "open";
export const isClosed = (state: UIState): boolean => state === "closed";
